import { reportingPrisma as prisma } from "client";

export const getPublishedEventsPerDay = async ({
  whiteLabelId,
  filters,
}: {
  whiteLabelId: string;
  filters: { [key: string]: string };
}) => {
  try {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const fromIso = new Date(filters.fromDate).toISOString();
    const toIso = new Date(filters.toDate).toISOString();

    const stages = [
      { $sort: { _id: -1 } },
      {
        $match: {
          whiteLabelId: { $oid: whiteLabelId },
          $expr: {
            $and: [
              {
                $gte: [
                  { $toDate: "$createdAt" },
                  { $toDate: fromIso },
                ],
              },
              {
                $lte: [
                  { $toDate: "$createdAt" },
                  { $toDate: toIso },
                ],
              },
            ],
          } as any,
        },
      },
      {
        $addFields: {
          date: {
            $dateToString: {
              format: "%d/%m/%Y",
              date: "$createdAt",
              timezone: userTimeZone,
            },
          },
        },
      },
      {
        $group: {
          _id: {
            date: "$date",
          },
          Events: { $sum: 1 },
        },
      },
      {
        $addFields: {
          date: "$_id.date",
        },
      },
      { $sort: { _id: 1 } },
    ];
    const result = await prisma.event.aggregateRaw({
      pipeline: [...stages],
    });
    return result || [];
  } catch (error) {
    console.error(error);
    throw error;
  }
};
